import { Product } from "@omni/types/api/product/bff/product.model";
import { ProductFieldSet } from "@omni/types/api/product/bff/shared/enums/productFieldSet.enum";
import { ProductSliderSources } from "@omni/types/components/product/enums/productSliderResource.enum";
import { isDefined } from "@omni/utils/helper.utils";
import { createContext, ReactNode, use } from "react";

import { BreakpointMinSizes } from "@/services/breakpoint.service";
import { LayoutSettings } from "@/utils/swiper.utils";

type ProductSliderContextValue = {
    title?: string | null;
    source: ProductSliderSources;
    breakpointsConfig: {
        layoutSettings: LayoutSettings;
        hidden: Array<BreakpointMinSizes>;
    };
    productTileConfig: {
        allowInstantAddToCart: boolean;
        amountOfFeatures: number;
        showButton: boolean;
        showCategoryLink: boolean;
        useInsidePadding: boolean;
    };
    prefetchedProducts?: Array<Product<ProductFieldSet.ProductTile>>;
    analyticsContext?: {
        list: string;
        listTitle: string;
    };
};

type ProductSliderContextProviderProps = {
    children: ReactNode;
    title?: string | null;
    source: ProductSliderSources;
    breakpointsConfig: {
        layoutSettings: LayoutSettings;
        hidden: Array<BreakpointMinSizes>;
    };
    productTileConfig: {
        allowInstantAddToCart: boolean;
        amountOfFeatures: number;
        showButton: boolean;
        showCategoryLink: boolean;
        useInsidePadding: boolean;
    };
    prefetchedProducts?: Array<Product<ProductFieldSet.ProductTile>>;
};

export const ProductSliderContext = createContext<
    ProductSliderContextValue | undefined
>(undefined);
ProductSliderContext.displayName = "ProductSliderContext";

export const ProductSliderContextProvider = ({
    children,
    ...props
}: ProductSliderContextProviderProps) => {
    return (
        <ProductSliderContext value={props}>{children}</ProductSliderContext>
    );
};

export const useProductSliderContext = () => {
    const context = use<ProductSliderContextValue | undefined>(
        ProductSliderContext
    );

    if (!isDefined(context)) {
        throw new Error(`${ProductSliderContext.displayName} is undefined.`);
    }

    return context;
};
